import React, {useState, useEffect, useRef} from 'react';
import {EmailField} from '../fields/text-like-field';
import ActionButton from '../buttons/action-button';
import CenteredSpinner from '../spinners/centered-spinner';

const EmailAddresses = ({minEmailAddresses, initialModel, onChange, sendTestEmailAction, errorHandler}) => {

  const modelRef = useRef();
  const [model, setModel] = useState(initialModel || []);

  useEffect(() => {
    if (model) {
      onChange(model.filter(e => !!e));
    } else if (modelRef.current) {
      setModel(modelRef.current);
      modelRef.current = null;
    }
  }, [model]);

  if (!model) {
    return <CenteredSpinner/>;
  }
  return <ul className="list-group">
    {model.map((emailAddress, i) => <li key={i} className="list-group-item">
      <div className="row">
        <div className="col">
          <EmailField noMargin={true}
                      placeholder="Enter an email"
                      value={emailAddress}
                      onChange={v => setModel(model.map((email, j) => i === j ? v : email))}/>
        </div>
        {sendTestEmailAction &&
        <div className="col-auto">
          <ActionButton className="btn-sm btn-secondary px-2"
                        action={() => sendTestEmailAction(emailAddress || '')}
                        errorHandler={errorHandler}
                        disabled={!emailAddress}>
            Send test email
          </ActionButton>
        </div>
        }
        <div className="col-auto">
          <button type="button"
                  className="btn btn-sm btn-danger"
                  onClick={() => {
                    modelRef.current = model.filter((email, j) => i !== j);
                    setModel(null);
                  }}
                  disabled={minEmailAddresses != null && model.length <= minEmailAddresses}>
            <span className="material-icons align-middle">&#xE872;</span>
          </button>
        </div>
      </div>
    </li>)}
    <li className="list-group-item">
      <div className="row justify-content-end">
        <div className="col-auto">
          <button type="button"
                  className="btn btn-sm btn-success"
                  onClick={() => setModel([...model, ''])}>
            {model.length > 0 ?
              <span className="material-icons align-middle">&#xE145;</span> :
              'Add email'
            }
          </button>
        </div>
      </div>
    </li>
  </ul>;

};

export default EmailAddresses;
